import { createRoot } from 'react-dom/client';
import '@lili/lili-frontend-common/dist/styles.css';
import './index.css';
import { InitApp } from './InitApp.tsx';

createRoot(document.getElementById('root')!).render(
  <>
    <InitApp />
  </>
);
